var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorkspaceicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12297_17542",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12297_17542)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.61538 20C4.15513 20 3.77083 19.8458 3.4625 19.5375C3.15417 19.2292 3 18.8449 3 18.3846V8.61538C3 8.15513 3.15417 7.77083 3.4625 7.4625C3.77083 7.15417 4.15513 7 4.61538 7H9V5.61537C9 5.15512 9.15417 4.77083 9.4625 4.4625C9.77083 4.15417 10.1551 4 10.6154 4H13.3846C13.8449 4 14.2292 4.15417 14.5375 4.4625C14.8458 4.77083 15 5.15512 15 5.61537V7H19.3846C19.8449 7 20.2292 7.15417 20.5375 7.4625C20.8458 7.77083 21 8.15513 21 8.61538V18.3846C21 18.8449 20.8458 19.2292 20.5375 19.5375C20.2292 19.8458 19.8449 20 19.3846 20H4.61538ZM10 7H14V5.61537C14 5.46152 13.9359 5.3205 13.8077 5.1923C13.6795 5.0641 13.5385 5 13.3846 5H10.6154C10.4615 5 10.3205 5.0641 10.1923 5.1923C10.0641 5.3205 10 5.46152 10 5.61537V7ZM20 14.5H14V15.1923C14 15.4244 13.9234 15.617 13.7702 15.7702C13.617 15.9234 13.4244 16 13.1923 16H10.8077C10.5756 16 10.383 15.9234 10.2298 15.7702C10.0766 15.617 10 15.4244 10 15.1923V14.5H4V18.3846C4 18.5385 4.0641 18.6795 4.1923 18.8077C4.32052 18.9359 4.46154 19 4.61538 19H19.3846C19.5385 19 19.6795 18.9359 19.8077 18.8077C19.9359 18.6795 20 18.5385 20 18.3846V14.5ZM11 15H13V13H11V15ZM4 13.5H10V12.8077C10 12.5756 10.0766 12.383 10.2298 12.2298C10.383 12.0766 10.5756 12 10.8077 12H13.1923C13.4244 12 13.617 12.0766 13.7702 12.2298C13.9234 12.383 14 12.5756 14 12.8077V13.5H20V8.61538C20 8.46154 19.9359 8.32052 19.8077 8.1923C19.6795 8.0641 19.5385 8 19.3846 8H4.61538C4.46154 8 4.32052 8.0641 4.1923 8.1923C4.0641 8.32052 4 8.46154 4 8.61538V13.5Z",
    fill: "#627082"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkspaceicon);
export default __webpack_public_path__ + "static/media/Workspace icon.ec8b8301ef9682663bcec0ab3fbcda9e.svg";
export { ForwardRef as ReactComponent };